import { StopNew } from "../../../ducks/data/route-with-stops/types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useAppDispatch } from "../../../redux-store";
import { deleteStop } from "../../../ducks/data/route-with-stops";

import { useParams } from "../../SessionsPage/hooks";

const DeleteStopModalAndButton = (props: {
  stop: StopNew;
  disabled?: boolean;
  onDeleteSuccessful?: () => void;
}) => {
  const { t } = useTranslation(["stopPage", "components"]);
  const [showConfirmDeleteStopDialog, setShowConfirmDeleteStopDialog] =
    useState(false);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const params = useParams();
  const routeId = (params.routeId as string) || "";
  const dispatch = useAppDispatch();

  const onConfirmDelete = async () => {
    setRequestInProgress(true);
    dispatch(
      deleteStop({
        stopId: props.stop.id,
        cargoId: props.stop.cargoId,
        routeId,
      })
    )
      .unwrap()
      .then(() => {
        setShowConfirmDeleteStopDialog(false);
        if (props.onDeleteSuccessful) {
          props.onDeleteSuccessful();
        }
      })
      .catch(() => {
        // Already reported and shown by the thunk.
      })
      .finally(() => {
        setRequestInProgress(false);
      });
  };

  return (
    <>
      <Dialog
        open={showConfirmDeleteStopDialog}
        onClose={() => setShowConfirmDeleteStopDialog(false)}
      >
        <DialogTitle>{t("stopPage:confirmDeleteStopDialog.title")}</DialogTitle>
        <DialogContent>
          {t("stopPage:confirmDeleteStopDialog.body")}
        </DialogContent>
        <DialogActions>
          <div className="flex gap-2 justify-between w-100 mt-4">
            <Button
              variant="outlined"
              disabled={requestInProgress}
              onClick={() => setShowConfirmDeleteStopDialog(false)}
            >
              {t("components:buttonLabels.cancel")}
            </Button>
            <Button
              variant="contained"
              color="error"
              // size="large"
              loading={requestInProgress}
              onClick={onConfirmDelete}
              disabled={requestInProgress}
            >
              {t("components:buttonLabels.delete")}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
      <Button
        variant="contained"
        size="large"
        color="error"
        disabled={props.disabled}
        onClick={() => setShowConfirmDeleteStopDialog(true)}
      >
        {t("stopPage:deleteStop")}
      </Button>
      {props.disabled && (
        <div className="mt-2">
          {t("stopPage:cannotDeleteFirstPickupDisabledText")}
        </div>
      )}
    </>
  );
};

export default DeleteStopModalAndButton;
